export const SUCCESS_ALERT = "SUCCESS_ALRET";
export const WARNING_ALERT = "WARNING_ALERT";
export const ERROR_ALERT = "ERROR_ALERT";
export const INFO_ALERT = "INFO_ALERT";

export const successAlert = (alerts) => {
  return {
    type: SUCCESS_ALERT,
    alerts,
  };
};

export const successAlertDispatcher = (alert) => {
  return (dispatch) => {
    dispatch(successAlert(alert));
    setTimeout(() => {
      dispatch(successAlert({}));
    }, 3000);
    return new Promise(function (resolve) {
      resolve(alert);
    });
  };
};

// warning alerts
export const warningAlert = (alerts) => {
  return {
    type: WARNING_ALERT,
    alerts,
  };
};

export const warningAlertDispatcher = (alert) => {
  return (dispatch) => {
    dispatch(warningAlert(alert));
    setTimeout(() => {
      dispatch(successAlert({}));
    }, 3000);
    return new Promise(function (resolve) {
      resolve(alert);
    });
  };
};

// info alerts
export const infoAlert = (alerts) => {
  return {
    type: INFO_ALERT,
    alerts,
  };
};

export const infoAlertDispatcher = (alert) => {
  return (dispatch) => {
    dispatch(infoAlert(alert));
    setTimeout(() => {
      dispatch(successAlert({}));
    }, 3000);
    return new Promise(function (resolve) {
      resolve(alert);
    });
  };
};

// error alerts
export const errorAlert = (alerts) => {
  return {
    type: ERROR_ALERT,
    alerts,
  };
};

export const errorAlertDispatcher = (alert) => {
  return (dispatch) => {
    dispatch(errorAlert(alert));
    setTimeout(() => {
      dispatch(successAlert({}));
    }, 3000);
    return new Promise(function (resolve) {
      resolve(alert);
    });
  };
};
